import React, { useState, useContext } from 'react'
import PropertyListTable from '../PropertyListTable/PropertyListTable'
// import FloorPlanTable from '../FloorPlanTable/FloorPlanRow'
import AddPropertyToList from '../AddPropertytoList/AddPropertyToList'
import { UnfoldMore, UnfoldLess } from '@material-ui/icons'
import listContext from '../../Common/context/context'
// import DeleteIcon from '@material-ui/icons/Delete'
import { makeStyles } from '@material-ui/core/styles'
import { ExpandLess } from '@material-ui/icons'
import SortPropertyListTable from '../PropertyListTable/SortPropertyListTable/SortPropertyListTable'
import updatePropertyList from '../Utility/UpdatePropertyList/UpdatePropertyList'
// import { deleteCompsListProperty } from '../Services/PropertyListService'
import { useKeycloak } from '@react-keycloak/web'
import Modal from 'react-modal'
import { getUserSFId, getPollingAlertDuration, getErrorAlertDuration } from '../../PropertySearch/Utility/Utility'
import OtherListOptions from '../OtherListOptions/OtherListOptions'
import { pollMessageStatus } from '../Utility/GetMessageStatus/GetMessageStatus'
import searchContext from '../../PropertySearch/FiltersComponent/context/context'

const useStyles = makeStyles({
    scrollBtn: {
        'display': 'none',
        'position': 'fixed',
        'bottom': '20px',
        'right': '20px',
        'z-index': '99',
        'cursor': 'pointer'
    },
})

const CompsPage = () => {

    const [showAllDetails, setshowAllDetails] = useState(false)
    const [deleteList, setDeleteList] = useState([])
    const [view, setView] = useState('overview') // floorplan overview
    const { propertyList, fetchListDetails } = useContext(listContext)
    const classes = useStyles()
    const [deleteClicked, setDeleteClicked] = useState(false)
    const { keycloak } = useKeycloak()
    const [selectedOption, setSelectedOption] = React.useState('')
    const [modalIsOpen, setIsOpen] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null)
    const { fetchSavedLists, setShowAlert, setalertProps, openModalWindow } = useContext(searchContext)

    const getPropertyCount = () => {
        return propertyList && propertyList.compsList ? propertyList.compsList.length : ''
    }

    window.onscroll = function () { scrollFunction() }

    function scrollFunction() {
        let btnScrollTop = document.getElementById("btnScrollTop")
        if (btnScrollTop) {
            if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
                btnScrollTop.style.display = "block";
            } else {
                btnScrollTop.style.display = "none";
            }
        }
    }

    function topFunction() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        })
    }

    const onUpdate = async (message, type) => {

        try {

            if (type === 'success') {
                fetchSavedLists()
                await fetchListDetails()
            }
            setDeleteClicked(false)
            setalertProps({ message, type, duration: type === 'error' ? getErrorAlertDuration() : '' })
            setShowAlert(true)

            openModalWindow(false)

            // switch (type) {
            //     case 'success':
            //         // let compsList = [...propertyList.compsList]
            //         // let updatedCompsList = compsList.filter(x => !deleteList.includes(x.omniViewPropertyId))
            //         // let newPropertyList = { ...propertyList }
            //         // newPropertyList.compsList = [...updatedCompsList]
            //         // setPropertyList(newPropertyList)

            //         fetchSavedLists()
            //         await fetchListDetails()
            //         setDeleteList([])

            //         setalertProps({ message, type })
            //         setShowAlert(true)

            //         setDeleteClicked(false)
            //         // setRefreshSavedSearch(!refreshSavedSearch)
            //         closeModal()
            //         break;

            //     case 'error':
            //         setalertProps({ message, type, duration: getErrorAlertDuration() })
            //         setShowAlert(true)
            //         setDeleteClicked(false)
            //         break;

            //     default: // type is warning
            //         setalertProps({ message, type, duration: getPollingAlertDuration() })
            //         setShowAlert(true)
            //         break;
            // }

        } catch (error) {
            console.log(' error in on-Update :: ', error)
        }

    }

    const onRemoveClick = async () => {

        let fieldsToUpdate = []
        // let tempDeleteList = []
        let compsList = [...propertyList.compsList]
        setDeleteClicked(true)

        let updatedCompsList = compsList.filter(x => deleteList.includes(x.omniViewPropertyId))

        fieldsToUpdate.push({
            key: 'compsList', value: updatedCompsList.map(item => ({
                "omniViewCompsListId": item.omniViewCompsListId,
                "omniViewPropertyId": item.omniViewPropertyId,
                // "isSubjectProperty": item.isSubjectProperty,
                // "rank": item.rank,
                "action": "delete"
            }))
        })
        fieldsToUpdate.push({ key: 'compType', value: propertyList.compType })

        fieldsToUpdate.push({ key: 'lastModifiedById', value: getUserSFId() })
        fieldsToUpdate.push({ key: 'omniViewPropertyListId', value: propertyList.omniViewPropertyListId })
        fieldsToUpdate.push({ key: 'polarisPropertySearchCriteriaId', value: propertyList.polarisPropertySearchCriteriaId })

        openModalWindow(true)
        closeModal()
        const updatePropertyListObj = new updatePropertyList(fieldsToUpdate)
        const response = await updatePropertyListObj.update()

        if (response && response.status === 200) {
            pollMessageStatus(response.data.messageId, onUpdate, '', 'Property Removed from list', 'Something went wrong !!')
        } else {
            const errorMessage = response.data && response.data.message ? response.data.message : 'Something went wrong !!'
            setalertProps({ message: errorMessage, type: 'error' })
            setShowAlert(true)
            setDeleteClicked(false)
        }
    }

    function openModal(inpuVal) {
        setSelectedOption(inpuVal)
        setIsOpen(true)
        handleClose()
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    function closeModal() {
        if (!deleteClicked) {
            setIsOpen(false)
        }
    }

    const customStyles = {
        content: {
            top: '30%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -40%)',
            padding: '10px'
        },
        overlay: { zIndex: 1050 }
    }

    return (
        <>
            <button data-testid="test-btn-scroll-to-top" className={`btn bg-gray-80 text-white rounded-full ${classes.scrollBtn}`} onClick={() => topFunction()} id="btnScrollTop" title="Go to top">
                <ExpandLess></ExpandLess>
            </button>
            <div id="container-div-CompsPage" data-testid="test-container-div-CompsPage" className="grid grid-cols-1 md:grid-cols-12 text-2">
                <div className="md:col-span-12 mx-3 md:mx-8 overflow-hidden ">
                    <div className="w-full flex flex-col space-y-4">
                        <div className="flex flex-row justify-between">
                            <div className="flex flex-row items-center">
                                <div className="border-r-1 border-base pr-4 font-semibold">
                                    <label>{`${getPropertyCount()} Properties`}</label>
                                </div>
                                <div className="px-4">
                                    <AddPropertyToList />
                                </div>
                                <div className="">
                                    <OtherListOptions />
                                </div>
                            </div>
                            <div className="flex flex-row items-center">
                                <div className="pr-4 flex flex-row space-x-4">
                                    <div>
                                        <input className="mt-3" type="radio" id="overview" name="view" value="overview"
                                            checked={view === 'overview' ? true : false} onClick={() => { setView('overview') }}
                                            data-testid="radio-input-overview" />
                                        <label for="overview" className="pl-3 text-2" >Overview</label>
                                    </div>
                                    <div>
                                        <input disabled={propertyList && propertyList.compType.toLowerCase() === 'sales'} className="mt-3" type="radio" id="floorplan" name="view" value="floorplan"
                                            checked={view === 'floorplan' ? true : false} onClick={() => { setView('floorplan') }}
                                            data-testid="radio-input-floorplan" />
                                        <label for="floorplan" className="pl-3 text-2" >Floor Plan</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="flex flex-row justify-between">
                                <div className="flex flex-row items-center">

                                </div>
                                <div className="flex flex-row items-center">
                                    {deleteList.length === 0 ?
                                        <button data-testid='btn-remove-selected-property' hidden className="btn btn-sm 'border-1 border-base" onClick={() => onRemoveClick()}>
                                            <span >Remove Selected Property</span>
                                        </button>
                                        : <div className="border-r-1 border-base pr-4">
                                            {deleteClicked ?
                                                <button id="myDiv" className="btn btn-sm btn-primary c-disabled">
                                                </button>
                                                :
                                                <button className="btn btn-sm 'border-1 border-base" onClick={() => openModal(<div data-testid="test-delete-select-property-popup" className='flex flex-col py-4 gap-4 drawer-w'>
                                                    <div className='flex flex-row border-b-1 border-base pb-2'>
                                                        <span className='p-3'>
                                                            <span className='font-semibold text-4'>{deleteList.length === 1 ? `Remove ${deleteList[0]} from list?` : ''}</span>
                                                        </span>
                                                    </div>
                                                    <div className='py-2 px-4'>
                                                        <div className='flex justify-end space-x-4 mt-auto'>
                                                            <div>
                                                                <button data-testid='test-delete-property-cancel' onClick={closeModal} className='btn btn-sm' type='button'>Close</button>
                                                            </div>
                                                            <div>
                                                                {deleteClicked ?
                                                                    <button className="btn btn-sm btn-primary c-disabled">
                                                                        <span className="loader h-5 w-5 mx-2" ></span>
                                                                        <span className="px-2">Confirm</span>
                                                                    </button>
                                                                    :
                                                                    <button data-testid='test-delete-property-confirm' onClick={() => onRemoveClick()} className={`btn btn-sm btn-primary`}>Confirm</button>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>)}>
                                                    <span >Remove Selected Property</span>
                                                </button>
                                            }
                                        </div>}
                                    <Modal ariaHideApp={false} isOpen={modalIsOpen} onRequestClose={closeModal}
                                        closeTimeoutMS={500} style={customStyles} >
                                        <div data-testid="test-delete-select-property-popup" className='flex flex-col py-4 gap-4 drawer-w'>
                                            <div className='flex flex-row border-b-1 border-base pb-2'>
                                                <span className='p-3'>
                                                    <span className='text-3'>Selected property will be removed from the list ?</span>
                                                </span>
                                            </div>
                                            <div className='py-2 px-4'>
                                                <div className='flex justify-end space-x-4 mt-auto'>
                                                    <div>
                                                        <button data-testid='test-delete-property-cancel' onClick={closeModal} className='btn btn-sm' type='button'>Close</button>
                                                    </div>
                                                    <div>
                                                        {deleteClicked ?
                                                            <button className="btn btn-sm btn-primary c-disabled">
                                                                <span className="loader h-5 w-5 mx-2" ></span>
                                                                <span className="px-2">Confirm</span>
                                                            </button>
                                                            :
                                                            <button data-testid='test-delete-property-confirm' onClick={() => onRemoveClick()} className={`btn btn-sm btn-primary`}>Confirm</button>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Modal>
                                    <div className="border-r-1 border-base pr-4 px-4">
                                        <SortPropertyListTable />
                                    </div>
                                    <div className="px-4">
                                        <button className={`btn btn-sm ${showAllDetails ? 'bg-gray-20' : 'border-1 border-base'}`} onClick={() => setshowAllDetails(!showAllDetails)}>
                                            <span className="pr-2" >
                                                {showAllDetails ? <UnfoldLess fontSize="small" /> : <UnfoldMore fontSize="small" />}
                                            </span>
                                            <span >{showAllDetails ? 'Collapse list' : 'Expand list'}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            {propertyList && view === 'floorplan' ?
                                <PropertyListTable view='floorplan' showAllDetails={showAllDetails} deleteList={deleteList} setDeleteList={setDeleteList} />
                                : null}
                            {propertyList && view === 'overview' ?
                                <PropertyListTable view='overview' showAllDetails={showAllDetails} deleteList={deleteList} setDeleteList={setDeleteList} />
                                : null}
                        </div>
                        <div>

                        </div>
                    </div>
                </div>
                {/* <div className="overflow-hidden "> </div> */}
            </div>


        </>
    )
}

// HeadBar.propTypes = {
//     view: PropTypes.string
// }

export default CompsPage
